/*eslint global-require:off*/
import { getJSON, setJSON, setStoragePrefix } from 'glov/client/local_storage';
setStoragePrefix('glovjs-playground'); // Before requiring anything else that might load from this

import assert from 'assert';
import * as engine from 'glov/client/engine';
import * as input from 'glov/client/input';
import * as net from 'glov/client/net';
import * as ui from 'glov/client/ui';
import { soundLoad, soundOnLoadFail, soundPlayMusic } from 'glov/client/sound';
import { GlovSoundScape } from 'glov/client/soundscape';
import { SOUNDSCAPE_DATA } from './soundscape_data';
import { clone } from 'glov/common/util';

const settings = require('glov/client/settings.js');
const { ceil, floor } = Math;

window.Z = window.Z || {};
Z.BACKGROUND = 1;
Z.SPRITES = 10;
Z.PARTICLES = 20;
Z.UI_TEST = 200;

// let app = exports;
// Virtual viewport for our game logic
export const game_width = 320;
export const game_height = 240;

export let sprites = {};

let excl_group_off = getJSON('excl_group_off', {});

const STREAMING = true;
const ENABLE_LOGS = true;
const ADD_ALL = true;
const KILL_DELAY = 500;
const TAG_TOLERANCE = 2000;

function procParams(params) {
  let ret = clone(params);
  function checkMasterLayer(layer) {
    layer.files = layer.files.filter((file) => {
      let { excl_group } = file;
      if (excl_group && excl_group_off[excl_group]) {
        return false;
      }
      return true;
    });
  }
  for (let key in ret.layers) {
    let layer = ret.layers[key];
    if (!layer.excl_group_master) {
      continue;
    }
    checkMasterLayer(layer);
    for (let tag in layer.tags) {
      checkMasterLayer(layer.tags[tag]);
    }
  }
  ret.streaming = STREAMING;
  ret.enable_logs = ENABLE_LOGS;
  ret.add_all = ADD_ALL;
  ret.kill_delay = KILL_DELAY;
  ret.tag_tolerance = TAG_TOLERANCE;
  return ret;
}

export function main() {
  if (engine.DEBUG) {
    // Enable auto-reload, etc
    net.init({ engine });
  }

  const font_info_04b03x1 = require('./img/font/04b03_8x1.json');
  let font = { info: font_info_04b03x1, texture: 'font/04b03_8x1' };

  if (!engine.startup({
    font,
    game_width,
    game_height,
    pixely: 'on',
    viewport_postprocess: false,
  })) {
    return;
  }
  gl.clearColor(0, 0, 0, 1);

  font = engine.font;

  // Perfect sizes for pixely modes
  ui.scaleSizes(13 / 32);
  ui.setFontHeight(8);

  let ss;
  let intensity = 0.1;
  let ss_params = SOUNDSCAPE_DATA;
  let master_excl_groups;
  function initGraphics() {
    soundLoad('soundscape/milestone', { streaming: true });
    soundLoad('soundscape/scenario', { streaming: true });

    ss = new GlovSoundScape(procParams(ss_params));

    master_excl_groups = {};
    function addMasterLayer(layer) {
      for (let ii = 0; ii < layer.files.length; ++ii) {
        let file = layer.files[ii];
        let { excl_group } = file;
        if (excl_group) {
          assert(!Array.isArray(excl_group), 'Master layer cannot have arrays for exclusion groups');
          master_excl_groups[excl_group] = true;
        }
      }
    }
    for (let key in ss_params.layers) {
      let layer = ss_params.layers[key];
      if (!layer.excl_group_master) {
        continue;
      }
      addMasterLayer(layer);
      for (let tag in layer.tags) {
        addMasterLayer(layer.tags[tag]);
      }
    }
    master_excl_groups = Object.keys(master_excl_groups);
    master_excl_groups.sort();
  }

  let colors_on = ui.makeColorSet([0.5, 1, 0.5, 1]);
  let colors_off = ui.makeColorSet([1, 0.5, 0.5, 1]);
  let sound_errors = [];
  soundOnLoadFail((filename) => sound_errors.push(filename));
  function test(dt) {
    let x = ui.button_height;
    let button_spacing = ui.button_height + 2;
    let y = game_height - 10 - button_spacing * 6;
    let z = Z.UI;

    settings.volume = ui.slider(settings.volume, {
      x, y, z,
      min: 0,
      max: 1,
    });
    ui.print(null, x + ui.button_width + 8, y, z, `Vol: ${settings.volume.toFixed(2)}`);
    y += ui.button_height + 2;

    intensity = ui.slider(intensity, {
      x, y, z,
      min: 0,
      max: 1,
    });
    ss.setIntensity(intensity);
    ui.print(null, x + ui.button_width + 8, y, z, `Int: ${intensity.toFixed(2)}`);
    y += ui.button_height + 2;

    function tagButton(tag_id) {
      let tag_time = ss.getTagTime(tag_id) ? ` [${floor(ss.getTagTime(tag_id) / 100)/ 10}s]` : '';
      let text = `${tag_id} = ${ss.getTag(tag_id) ? 'ON' : 'Off'}${tag_time}`;
      if (ui.buttonText({ x, y, text, rollover_quiet: true })) {
        ss.setTag(tag_id, !ss.getTag(tag_id));
      }
      y += button_spacing;
    }

    tagButton('home');
    tagButton('night');
    tagButton('snow');
    tagButton('underground');
    tagButton('underwater');
    if (ui.buttonText({ x, y, text: 'Play fanfare', rollover_quiet: true })) {
      soundPlayMusic(['soundscape/milestone', 'soundscape/scenario'][Math.floor(Math.random() * 2)]);
    }
    y += button_spacing;

    y = game_height/2;
    for (let ii = 0; ii < sound_errors.length; ++ii) {
      ui.print(font.styleColored(null, 0xFF0000ff), x, y, z - 10, `Failed to load: "${sound_errors[ii]}"`);
      y += ui.font_height;
    }


    x = 0;
    y = 5;
    let debug = ss.debug();
    let solo = null;
    for (let ii = 0; ii < debug.length; ++ii) {
      ui.print(null, x, y, z, debug[ii].text);
      if (debug[ii].hover && input.keyDown(input.KEYS.SHIFT) && input.mouseOver({ x, y, w: 80, h: ui.font_height })) {
        solo = debug[ii].hover;
        ui.drawRect(x, y, x + 80, y + ui.font_height, z - 1, [0.5,0.5,0,1]);
      }
      y += ui.font_height;
    }
    ss.debugSolo(solo);

    // exclusion groups

    let num_columns = 3;
    let button_width = ui.button_width/2;
    x = game_width/2;
    y = game_height - ceil(master_excl_groups.length / num_columns) * button_spacing;
    y -= button_spacing;

    if (ui.buttonText({
      x: game_width/2,
      y: y - button_spacing,
      w: button_width,
      text: settings.music ? 'Music On' : 'Music off',
      rollover_quiet: true
    })) {
      settings.music = (settings.music - 1) * -1;
      console.log(`settings.music set to ${settings.music}`);
    }

    if (ui.buttonText({
      x: game_width/2 + (button_width + 2),
      y: y - button_spacing,
      w: button_width,
      text: settings.sound ? 'Sound On' : 'Sound off',
      rollover_quiet: true
    })) {
      settings.sound = (settings.sound - 1) * -1;
      console.log(`settings.sound set to ${settings.sound}`);
    }

    y += button_spacing;

    if (ui.buttonText({
      x: game_width/2,
      y: y - button_spacing,
      w: button_width,
      text: 'All on',
      rollover_quiet: true
    })) {
      for (let ii = 0; ii < master_excl_groups.length; ++ii) {
        let key = master_excl_groups[ii];
        excl_group_off[key] = false;
        setJSON('excl_group_off', excl_group_off);
        ss.stopAllLayers(1);
        ss = new GlovSoundScape(procParams(ss_params));
      }
      ss.stopAllLayers(1);
      ss = new GlovSoundScape(procParams(ss_params));
    }

    if (ui.buttonText({
      x: game_width/2 + button_width + 2,
      y: y - button_spacing,
      w: button_width,
      text: 'All off',
      rollover_quiet: true
    })) {
      for (let ii = 0; ii < master_excl_groups.length; ++ii) {
        let key = master_excl_groups[ii];
        excl_group_off[key] = true;
        setJSON('excl_group_off', excl_group_off);
        ss.stopAllLayers(1);
        ss = new GlovSoundScape(procParams(ss_params));
      }
      ss.stopAllLayers(1);
      ss = new GlovSoundScape(procParams(ss_params));
    }

    if (!ADD_ALL && ui.buttonText({
      x: game_width/2 + 2 * (button_width + 2),
      y: y - button_spacing,
      w: button_width,
      text: 'Load all',
      rollover_quiet: true
    })) {
      ss.addAll();
    }

    let ix = 0;
    for (let ii = 0; ii < master_excl_groups.length; ++ii, ++ix) {
      let key = master_excl_groups[ii];
      if (ix === 3) {
        ix = 0;
        y += button_spacing;
      }
      if (ui.buttonText({
        x: x + ix * (button_width + 2), y, text: key, w: button_width,
        colors: excl_group_off[key] ? colors_off : colors_on, rollover_quiet: true
      })) {
        excl_group_off[key] = !excl_group_off[key];
        setJSON('excl_group_off', excl_group_off);
        ss.stopAllLayers(1);
        ss = new GlovSoundScape(procParams(ss_params));
      }
    }

    ss.tick();
  }

  function testInit(dt) {
    engine.setState(test);
    test(dt);
  }

  initGraphics();
  engine.setState(testInit);
}
